export class DesktopOnlyPageError<R = unknown> extends Error {
  constructor(public data?: R) {
    super();
  }
}
